import React from "react";
import { IcoHome, IcoChevronRight } from "./Icons";

export default function Breadcrumb({ path, setPath }) {
  const parts = path ? path.split("/") : [];

  return (
    <nav className="breadcrumb" aria-label="Đường dẫn thư mục">
      <button
        className={`crumb ${parts.length === 0 ? "current" : ""}`}
        onClick={() => setPath("")}
      >
        <IcoHome size={15} />
        <span>Kho ảnh</span>
      </button>
      {parts.map((p, i) => {
        const sub = parts.slice(0, i + 1).join("/");
        const last = i === parts.length - 1;
        return (
          <React.Fragment key={sub}>
            <span className="crumb-sep" aria-hidden="true"><IcoChevronRight size={14} /></span>
            <button
              className={`crumb ${last ? "current" : ""}`}
              onClick={() => setPath(sub)}
              title={p}
            >
              <span>{p}</span>
            </button>
          </React.Fragment>
        );
      })}
    </nav>
  );
}
